/**
 * Public support form — server builds email; fixed inbox; rate limited.
 */
import { getApiEndpoint } from './apiBaseUrl';

/**
 * @param {{ name: string, email: string, subject: string, message: string, website?: string }} payload
 */
export async function submitSupportContact(payload) {
  const response = await fetch(getApiEndpoint('support-contact'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Failed to send message. Please try again.');
  }
  return data;
}
